import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/dashboard/dashboardLayout/dashboardLayout';
import { useGetDashboardById } from '../../apiHooks/queries/useGetDashboards';
import {
  useSetSelectedDashboard,
  useUpdateLayout,
} from '../../apiHooks/mutations/dashboardMutations/dashboardMutations';
import DashboardActions from '../../components/dashboard/dashboardActions/dashboardActions';
import LoadingSpinner from '../../components/loadingSpinner/loadingSpinner';
import { useDashboardFilterDateStore } from '../../store/dateRangeStore';
import { DASHBOARD_LAYOUT } from '../../constants/pageIdentifiers';

const Dashboard = () => {
  const dashboardFilterDateRange = useDashboardFilterDateStore((state) => state.dashboardFilterDateRange);
  const setDashboardFilterDateRange = useDashboardFilterDateStore((state) => state.setDashboardFilterDateRange);
  const [newLayout, setNewLayout] = useState(null);
  const [selectedDashboardOption, setSelectedDashboardOption] = useState<number>(0);
  const [isDefaultDashboard, setIsDefaultDashboard] = useState<boolean>(selectedDashboardOption === 0);

  const {
    data: selectedDashboardData,
    isFetching: isFetchingSelectedDashboardData,
    isError: isErrorSelectedDashboardData,
    refetch: refetchSelectedDashboardData,
  } = useGetDashboardById(DASHBOARD_LAYOUT, selectedDashboardOption);
  const { mutateAsync: updateLayout, isLoading: isUpdatingLayout } = useUpdateLayout(selectedDashboardOption);
  const { mutateAsync: setSelectedDashboard } = useSetSelectedDashboard();

  useEffect(() => {
    setIsDefaultDashboard(selectedDashboardOption === 0);
    setSelectedDashboard(selectedDashboardOption).then(() => {}, () => {});
    refetchSelectedDashboardData().then(() => {}, () => {});
    setNewLayout(null);
    setDashboardFilterDateRange(dashboardFilterDateRange);
  }, [selectedDashboardOption]);

  return (
    <>
      <DashboardActions
        selectedOption={selectedDashboardOption}
        setSelectedOption={setSelectedDashboardOption}
        refetchSelectedDashboardData={refetchSelectedDashboardData}
        updateLayout={updateLayout}
        isUpdatingLayout={isUpdatingLayout}
        setNewLayout={setNewLayout}
        newLayout={newLayout}
        selectedDashboardData={selectedDashboardData}
        filterRange={dashboardFilterDateRange}
        setFilterRange={setDashboardFilterDateRange}
        isDefaultDashboard={isDefaultDashboard}
      />
      {isDefaultDashboard ? (
        <DashboardLayout
          isDefaultDashboard={isDefaultDashboard}
        />
      ) : (
        <>
          {isFetchingSelectedDashboardData && <LoadingSpinner center color="primary" />}
          {isErrorSelectedDashboardData && !isFetchingSelectedDashboardData && (
            <p> There was a problem loading this dashboard </p>
          )}
          {!isFetchingSelectedDashboardData && !isErrorSelectedDashboardData && selectedDashboardData.data && (
            <DashboardLayout
              layoutData={selectedDashboardData.data}
              setNewLayout={setNewLayout}
            />
          )}
        </>
      )}
    </>
  );
};

export default Dashboard;
